'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { cn } from '@qogita/ui/utils/cn'
import { ComponentPropsWithoutRef } from 'react'

import { Icon } from '../v2/icon'
import { BaseButton } from './base-button'

type Align = 'center' | 'left' | 'right'

type TableCellProps = ComponentPropsWithoutRef<'td'> & {
  className?: string
  align?: Align
}

type TableHeaderProps = TableCellProps & {
  onClick?: React.MouseEventHandler
  sort?: 'ascending' | 'descending'
}

type TableContainerProps = ComponentPropsWithoutRef<'div'> & {
  className?: string
}

export function TableTh({
  align = 'center',
  className,
  onClick,
  children,
  sort,
  ...props
}: TableHeaderProps) {
  return (
    <th
      className={cn(
        'group relative table-cell w-1/2 bg-white px-6 py-3 text-ellipsis first:table-cell sm:w-auto',
        {
          'text-center': align === 'center',
          'text-left': align === 'left',
          'text-right': align === 'right',
        },
        className,
      )}
      role="columnheader"
      aria-sort={sort}
      {...props}
    >
      {onClick ? (
        <BaseButton
          onClick={onClick}
          className={cn('flex w-full items-center gap-2', {
            'justify-start': align === 'left',
            'justify-center': align === 'center',
            'justify-end': align === 'right',
          })}
        >
          <span className="text-base font-medium text-gray-900" {...props}>
            {children}
          </span>
          <span className="flex flex-col">
            <Icon
              name="heroicons/micro/chevron-up"
              className={cn('h-4 w-4', {
                'text-gray-400': sort !== 'ascending',
                'text-gray-700': sort === 'ascending',
              })}
            />
            <Icon
              name="heroicons/micro/chevron-down"
              className={cn('-mt-1 h-4 w-4', {
                'text-gray-400': sort !== 'descending',
                'text-gray-700': sort === 'descending',
              })}
            />
          </span>
        </BaseButton>
      ) : (
        <span className="text-base font-medium text-gray-900" {...props}>
          {children}
        </span>
      )}
    </th>
  )
}

export function TableTd({
  align = 'center',
  className,
  children,
  ...props
}: TableCellProps) {
  return (
    <td
      className={cn(
        'table-cell w-auto overflow-auto px-6 py-3 text-ellipsis text-gray-700 first:table-cell',
        {
          'text-center': align === 'center',
          'text-left': align === 'left',
          'text-right': align === 'right',
        },
        className,
      )}
      {...props}
    >
      {children}
    </td>
  )
}

export function TableTr({
  className,
  ...props
}: ComponentPropsWithoutRef<'tr'> & { className?: string }) {
  return (
    <tr
      className={cn(
        'border-b border-gray-300 odd:bg-gray-50 even:bg-white',
        className,
      )}
      {...props}
    />
  )
}

export function TableTBody({ ...props }: ComponentPropsWithoutRef<'tbody'>) {
  return <tbody {...props} />
}

export function TableTHead({ ...props }: ComponentPropsWithoutRef<'thead'>) {
  return <thead {...props} />
}

export function ScrollableTable({
  className,
  ...props
}: ComponentPropsWithoutRef<'table'> & { className?: string }) {
  return (
    <table
      className={cn('w-full overflow-scroll rounded-lg', className)}
      {...props}
    />
  )
}

export function TableContainer({
  className,
  children,
  ...divProps
}: TableContainerProps) {
  return (
    <div
      className={cn(
        'overflow-auto rounded-lg border border-gray-300',
        className,
      )}
      {...divProps}
    >
      {children}
    </div>
  )
}

export function TableTestComponent() {
  return (
    <ScrollableTable>
      <TableTHead>
        <TableTr>
          <TableTh align="left">Column 1</TableTh>
          <TableTh>Column 2</TableTh>
          <TableTh>Column 3</TableTh>
          <TableTh>Column 4</TableTh>
        </TableTr>
      </TableTHead>
      <TableTBody>
        <TableTr>
          <TableTd align="left">1st column content</TableTd>
          <TableTd>2nd column content</TableTd>
          <TableTd>3rd column content</TableTd>
          <TableTd>4th column content</TableTd>
        </TableTr>
        <TableTr>
          <TableTd align="left">Col 1</TableTd>
          <TableTd>Col 2</TableTd>
          <TableTd>Col 3</TableTd>
          <TableTd>Col 4</TableTd>
        </TableTr>
        <TableTr>
          <TableTd align="left">Col 1</TableTd>
          <TableTd>Col 2</TableTd>
          <TableTd>Col 3</TableTd>
          <TableTd>Col 4</TableTd>
        </TableTr>
      </TableTBody>
    </ScrollableTable>
  )
}
